import { Directive, TemplateRef, inject, input } from '@angular/core';

import type { GrCanvasContext } from '../canvas/canvas.types';

@Directive({
  selector: 'ng-template[grCanvasRenderer]',
})
export class GrCanvasRendererDirective<TConfig = unknown> {
  readonly kind = input.required<string>({ alias: 'grCanvasRenderer' });
  readonly templateRef = inject<TemplateRef<GrCanvasContext<TConfig>>>(TemplateRef);

  static ngTemplateContextGuard<T>(
    _dir: GrCanvasRendererDirective<T>,
    ctx: unknown,
  ): ctx is GrCanvasContext<T> {
    void _dir;
    void ctx;
    return true;
  }
}
